import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { listAdminClubs } from '../../api/admin';

export function AdminClubsTab() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['admin-clubs'],
    queryFn: listAdminClubs,
  });

  if (isLoading) return <div className="p-4">Loading clubs…</div>;
  if (error) return <div className="p-4 text-red-500">Failed to load clubs.</div>;
  if (!data || data.length === 0) return <div className="p-4 text-slate-500">No clubs yet.</div>;

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full text-sm">
        <thead className="text-left text-xs uppercase text-slate-500 dark:text-slate-400">
          <tr>
            <th className="px-3 py-2">Name</th>
            <th className="px-3 py-2">Owner</th>
            <th className="px-3 py-2">Members</th>
            <th className="px-3 py-2">Created</th>
            <th className="px-3 py-2">Last session</th>
            <th className="px-3 py-2">Active</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100 dark:divide-slate-700">
          {data.map(c => (
            <tr key={c.id} className="hover:bg-slate-50 dark:hover:bg-slate-800/50">
              <td className="px-3 py-2">
                <Link to={`/clubs/${c.id}`} className="text-teal-600 hover:underline">
                  {c.name}
                </Link>
              </td>
              <td className="px-3 py-2">{c.ownerDisplayName}</td>
              <td className="px-3 py-2">{c.memberCount}</td>
              <td className="px-3 py-2">{new Date(c.createdAt).toLocaleDateString()}</td>
              <td className="px-3 py-2">
                {c.lastSessionDate ? new Date(c.lastSessionDate).toLocaleDateString() : '—'}
              </td>
              <td className="px-3 py-2">{c.active ? 'Yes' : 'No'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
